export default __webpack_public_path__ + "static/Alliance_Autos_lockup-4603c1c4b8551bbed5211089b24ceb21.png";